import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';
import AutomationForm from '../../../components/Automation/AutomationForm';
import FormAlert from '../../../components/Common/Form/FormAlert';
import { useAutomation } from '../../../hooks/useAutomation';

const propTypes = {
  lobsangEventId: PropTypes.number.isRequired,
  kobeZones: PropTypes.arrayOf(PropTypes.string).isRequired,
};
const defaultProps = {};

function AutomationTab({ lobsangEventId, kobeZones }) {
  const { data: automationData, isLoading: isAutomationLoading, isError: isAutomationError } = useAutomation(
    lobsangEventId
  );

  if (isAutomationLoading) {
    return <CircularProgress />;
  }

  if (isAutomationError) {
    return <FormAlert variant="error">The automation data could not be loaded. Please try again later.</FormAlert>;
  }

  return <AutomationForm automationData={automationData} lobsangEventId={lobsangEventId} kobeZones={kobeZones} />;
}

AutomationTab.propTypes = propTypes;
AutomationTab.defaultProps = defaultProps;

export default AutomationTab;
